import { pxToRem } from '@/shared/styles/themes'
import { styled } from '@mui/material'

export const StyledContainer = styled('div')`
  position: relative;
  height: calc(100% - ${pxToRem(16)});
  background-color: ${({ theme }) => theme.palette.background.paper};
  width: 100%;
  border-radius: ${pxToRem(8)} 0 0 ${pxToRem(8)};
  box-shadow: 4pxpx 6px 8px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  padding: 0 0 ${pxToRem(8)} 0;
  margin: ${pxToRem(10)} 0 0 0;
`

export const StyledHeader = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${pxToRem(35)};
  background-color: ${({ theme }) => theme.palette.custom.mosaicWindowToolbar.backgroundColor};
  border-radius: ${pxToRem(8)} 0 0 0;
`

export const StyledContent = styled('div')`
  padding: ${pxToRem(8)};
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`
